import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "bg",
    lng: "bg",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: require("../locales/en/translation.json"),
      },
      est: {
        translation: require("../locales/est/translation.json"),
      },
      bg: {
        translation: require("../locales/bg/translation.json")
      }
    },
    detection: {
      order: ["localStorage", "queryString", "cookie"],
      caches: ["localStorage"],
    },
  });

export default i18n;
